import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { booklists, getComicsByIds } from "../../mocks/manga";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "妖精漫画网 精选书单",
  url: "https://readdiary.github.io/booklists",
  description: "由资深读者整理的漫画专题书单，涵盖治愈、热血、悬疑、国漫、科幻与恋爱等多种主题。",
  mainEntity: {
    "@type": "ItemList",
    itemListElement: booklists.map((b, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: b.name,
    })),
  },
};

export default function Booklists() {
  const featured = booklists[0];
  const rest = booklists.slice(1);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Navbar />

      <main>
        <section className="border-b border-background-200/70 bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <nav aria-label="面包屑" className="mb-4 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">书单</span>
            </nav>
            <h1 className="font-display text-3xl text-foreground-950 md:text-4xl">精选书单</h1>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              由资深读者按主题整理的作品合集。一份书单解锁一片新天地，找到志同道合的口味，追更找漫更省心。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-10 md:px-6">
          {featured && (
            <article className="mb-10 overflow-hidden rounded-3xl border border-background-200/70 bg-background-100">
              <div className="flex flex-col gap-6 p-6 md:flex-row md:items-center md:p-8">
                <img src={featured.cover} alt={`${featured.name} 书单封面`} className="h-44 w-32 shrink-0 rounded-2xl object-cover object-top" />
                <div className="min-w-0 flex-1">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                    <i className="ri-fire-fill" aria-hidden="true"></i> 今日推荐
                  </span>
                  <h2 className="mt-3 font-display text-2xl text-foreground-950 md:text-3xl">{featured.name}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.desc}</p>
                  <p className="mt-3 text-xs text-foreground-500">#{featured.tag} · {featured.count} 部 · 整理者：{featured.owner}</p>
                </div>
              </div>
              <div className="border-t border-background-200/70 bg-background-50 px-6 py-5 md:px-8">
                <h3 className="mb-4 text-sm font-bold text-foreground-950">书单收录</h3>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
                  {getComicsByIds(featured.comicIds).map((c) => (
                    <Link key={c.id} to={`/detail/${c.id}`} className="group flex items-center gap-3 rounded-xl border border-background-200/70 p-2 transition-colors hover:bg-background-100">
                      <img src={c.cover} alt={`${c.title} 封面`} className="h-16 w-11 shrink-0 rounded-md object-cover object-top" />
                      <div className="min-w-0">
                        <p className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600">{c.title}</p>
                        <p className="mt-1 text-xs text-foreground-400">{c.status}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </article>
          )}

          <h2 className="mb-6 font-display text-2xl text-foreground-950">更多书单</h2>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {rest.map((bl) => (
              <article key={bl.id} className="overflow-hidden rounded-3xl border border-background-200/70 bg-background-50">
                <div className="flex gap-5 p-6">
                  <img src={bl.cover} alt={`${bl.name} 书单封面`} className="h-40 w-28 shrink-0 rounded-2xl object-cover object-top" />
                  <div className="min-w-0">
                    <span className="inline-flex rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-bold text-secondary-900">#{bl.tag}</span>
                    <h3 className="mt-2 font-display text-xl leading-snug text-foreground-950">{bl.name}</h3>
                    <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{bl.desc}</p>
                    <p className="mt-3 text-xs text-foreground-500">{bl.count} 部 · 整理者：{bl.owner}</p>
                  </div>
                </div>
                <div className="border-t border-background-200/70 bg-background-100 px-6 py-4">
                  <div className="flex flex-wrap items-center gap-2">
                    {getComicsByIds(bl.comicIds).map((c) => (
                      <Link key={c.id} to={`/detail/${c.id}`} title={c.title} className="group">
                        <img src={c.cover} alt={`${c.title} 封面`} className="h-14 w-10 rounded-md border-2 border-background-50 object-cover object-top transition-transform group-hover:-translate-y-1" />
                      </Link>
                    ))}
                    <span className="flex h-14 items-center rounded-md border-2 border-background-50 bg-background-200 px-3 text-xs text-foreground-600">
                      +{bl.count - bl.comicIds.length}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}